import React from 'react'

const FatBackArrowIcon = () => (
  <svg
    width="71"
    height="60"
    viewBox="0 0 71 60"
    fill="none"
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M37.4542 6.84128C41.0052 4.47242 43.9135 5.62636 43.9135 9.8481L43.9416 16.8843H59.6277C62.339 16.904 64.5381 19.0853 64.5812 21.7956V38.3448C64.5277 41.0345 62.3174 43.1792 59.6277 43.1529H43.9416V49.8748C43.9416 54.1247 41.0052 55.668 37.4542 53.2991L9.07943 34.3764C5.52848 32.0075 5.52848 28.1423 9.07943 25.764L37.4542 6.84128Z"
      fill="#0069E4"
    />
  </svg>
)

export default FatBackArrowIcon
